// src/KlinikDanisanFormu.js (Tam Kod)
import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

function KlinikDanisanFormu({ mevcutDanisan, onFormSubmit, onIptal, diyetisyenler = [] }) {
  const [formData, setFormData] = useState({ ad: '', soyad: '', eposta: '', telefon: '', diyetisyen_id: '' });

  useEffect(() => {
    if (mevcutDanisan) {
      setFormData({
        ad: mevcutDanisan.ad || '',
        soyad: mevcutDanisan.soyad || '',
        eposta: mevcutDanisan.eposta || '',
        telefon: mevcutDanisan.telefon || '',
        diyetisyen_id: mevcutDanisan.diyetisyen_id || ''
      });
    }
  }, [mevcutDanisan]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleSubmit = (e) => { e.preventDefault(); onFormSubmit(formData); };

  return (
    <Form onSubmit={handleSubmit}>
      {/* Yeni danışan eklenirken gösterilecek diyetisyen seçme alanı */}
      {!mevcutDanisan && (
        <Form.Group className="mb-3">
          <Form.Label>Atanacak Diyetisyen</Form.Label>
          <Form.Select name="diyetisyen_id" value={formData.diyetisyen_id} onChange={handleChange} required>
            <option value="">Diyetisyen Seçiniz...</option>
            {diyetisyenler.map(d => <option key={d.id} value={d.id}>{d.kullanici_adi}</option>)}
          </Form.Select>
        </Form.Group>
      )}
      <Form.Group className="mb-3"><Form.Label>Ad</Form.Label><Form.Control type="text" name="ad" value={formData.ad} onChange={handleChange} required /></Form.Group>
      <Form.Group className="mb-3"><Form.Label>Soyad</Form.Label><Form.Control type="text" name="soyad" value={formData.soyad} onChange={handleChange} required /></Form.Group>
      <Form.Group className="mb-3"><Form.Label>E-posta</Form.Label><Form.Control type="email" name="eposta" value={formData.eposta} onChange={handleChange} /></Form.Group>
      <Form.Group className="mb-3"><Form.Label>Telefon</Form.Label><Form.Control type="tel" name="telefon" value={formData.telefon} onChange={handleChange} /></Form.Group>
      <div className="d-flex justify-content-end">
        <Button variant="secondary" onClick={onIptal} className="me-2">İptal</Button>
        <Button variant="primary" type="submit">{mevcutDanisan ? 'Güncelle' : 'Kaydet'}</Button>
      </div>
    </Form>
  );
}
export default KlinikDanisanFormu;